import { type GenerateLead } from '../../domain/usecase/generate-lead'
import { type HttpPostClient } from '../protocols/adapters/http-post-client'

export class Gt7GenerateLead implements GenerateLead {
  private readonly httpPostClient: HttpPostClient<any, any>
  private readonly defaultOptions = {
    event: 'GenerateLead',
    source: 'CartaodeTODOS-SONHOS',
    channel: 'cartao_de_todos_sonhos',
    campaign: 'passivo'
  }

  constructor (httpPostClient: HttpPostClient<any, any>) {
    this.httpPostClient = httpPostClient
  }

  async handle (params: GenerateLead.Params): Promise<void> {
    await this.httpPostClient.post({
      url: 'https://api.gt7.com.br/analytics/event',
      body: {
        ...this.defaultOptions,
        lead: params.lead
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }
}
